import MaterialIcon from '@/components/atom/MaterialIcon';
import ClickLogger from '@/components/common/ClickLogger';
import { EWebTreatmentRequestLog } from '@/entities/diagnosis/libs';
import { TreatmentRequestDoctor } from '@/models/diagnosis';
import { CustomPageProps } from '@/types/app';
import { DoctorDetail } from '@/types/doctor';
import { Alert } from 'doctornow-design-system';
import { useRouter } from 'next/router';
import { useRef } from 'react';
import 'react-spring-bottom-sheet/dist/style.css';
import { Drawer } from 'vaul';
import DoctorDetailInfo from './DoctorDetailInfo';

interface Props extends CustomPageProps {
  isOpen: boolean;
  onClose: () => void;
  handleSelectDoctor: (doctor?: TreatmentRequestDoctor, doctorPublicId?: string, doctorDetail?: DoctorDetail) => void;
  isEnabledScheduleAlertOpen: boolean;
  selectedStartDisplayTimeSlot: string;
  selectedDoctorDetail: DoctorDetail | null;
  onCloseIsEnabledScheduleAlert: () => void;
}
const DoctorDetailBottomSheet = ({
  isOpen,
  client,
  onClose,
  handleSelectDoctor,
  isEnabledScheduleAlertOpen,
  selectedStartDisplayTimeSlot,
  selectedDoctorDetail,
  onCloseIsEnabledScheduleAlert,
}: Props) => {
  const router = useRouter();
  const doctorId = router.query.doctorId as string;
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <Drawer.Root open={isOpen} dismissible={false}>
        <Drawer.Title />
        <Drawer.Portal>
          <Drawer.Content
            className={
              'fixed right-0 bottom-0 left-0 z-[261] mx-auto h-full w-full bg-white transition-opacity duration-500'
            }
          >
            <div ref={scrollContainerRef} className={'h-full overflow-y-auto'}>
              <ClickLogger
                params={{
                  eventName: EWebTreatmentRequestLog.CloseDoctorDetail,
                  payload: {
                    doctorId: doctorId ?? '',
                  },
                }}
              >
                <div className={'flex w-full justify-end p-[14px_16px]'} onClick={onClose}>
                  <span className={'p-[4px]'}>
                    <MaterialIcon name='close' />
                  </span>
                </div>
              </ClickLogger>
              <DoctorDetailInfo
                client={client}
                handleSelectDoctor={handleSelectDoctor}
                scrollContainerRef={scrollContainerRef}
              />
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>

      <Alert
        type='single'
        title={`${selectedStartDisplayTimeSlot} 예약이 마감되었어요.`}
        description={`${selectedDoctorDetail?.doctor.name} 의사의 ${selectedStartDisplayTimeSlot} 진료 예약이 마감 되었어요. 다른 의사를 선택해주세요.`}
        open={isEnabledScheduleAlertOpen}
        buttons={[
          {
            label: '의사 다시 선택',
            onClick: onCloseIsEnabledScheduleAlert,
          },
        ]}
      />
    </>
  );
};

export default DoctorDetailBottomSheet;
